import PageLayout from "./layouts/PageLayout";
import { Helmet } from "react-helmet-async";
import ServiceArea from "./layouts/ServiceArea";
import SearchWrapper from "./layouts/SearchWrapper";
import Header from "./layouts/Header";
import PageHeader from "./layouts/PageHeader";
import Footer from "./layouts/Footer";

export default function Services() {
  const canonical = "https://www.icellstation.com/services";

  // 1. Define JSON-LD as plain JS objects
  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.icellstation.com/",
      },
      { "@type": "ListItem", position: 2, name: "Services", item: canonical },
    ],
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "How long do most repairs take?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Most repairs are completed same day, often within 60–90 minutes.",
        },
      },
      {
        "@type": "Question",
        name: "Do you use quality parts?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, we use high-quality parts and provide a warranty.",
        },
      },
    ],
  };

  return (
    <PageLayout
      title="Device Repair Services in Willow Grove, PA | Cell Station"
      description="iPhone, iPad, Mac, PC & Android repairs, data recovery, and accessories. Same-day service with quality parts."
      url={canonical}
    >
      {/* 2. Output JSON-LD using JSON.stringify */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbJsonLd)}
        </script>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>

      <SearchWrapper />
      <Header />
      <PageHeader title="Services" />

      {/* SEO H1 for services landing page */}
      <div className="container" style={{ paddingTop: "40px", paddingBottom: "10px" }}>
        <h1 style={{ fontSize: "2rem", color: "#18305d", marginBottom: "12px", fontWeight: 700 }}>
          Mobile & Computer Repair Services in Willow Grove, PA
        </h1>
        <p style={{ color: "#555", fontSize: "1.05rem", maxWidth: "800px", lineHeight: 1.6 }}>
          Fast, reliable iPhone, Samsung, iPad, MacBook, and laptop repairs.
          Same-day service, 30-day warranty, and 19+ years of experience serving
          Willow Grove, Horsham, Abington, Hatboro, Warminster and the greater
          Philadelphia area.
        </p>
      </div>

      {/* 3. Your existing ServiceArea component */}
      <ServiceArea background />

      <Footer />
    </PageLayout>
  );
}

// import React, { useEffect } from 'react';
// import Section from './layouts/Section';
// import ServiceArea from './layouts/ServiceArea';

// const Services = () => {
//   useEffect(() => {
//     // ✅ Set browser tab title
//     document.title = 'Cell Station – Services | Expert Cellphone Repair';
//   }, []);

//   return (
//     <Section title={'Services'}>
//       <ServiceArea background={false} />
//     </Section>
//   );
// };

// export default Services;
